import { InstitutionId } from 'types';

export const INSTITUTIONS = '/api/v1/institutions';
export const INSTITUTION = (institutionId: InstitutionId) =>
    `/api/v1/institutions/${institutionId}`;
export const PRINCIPAL = (institutionId: InstitutionId) =>
    `/api/v1/institutions/${institutionId}/principal`;
export const INSTITUTIONS_EMPLOYEES = (institutionId: InstitutionId) =>
    `/api/v1/institutions/${institutionId}/employees`;
